import styled from 'styled-components'
import { Box } from '@mui/material'

export const DefaultWrapper = styled(Box)`
	background-color: #f9f9f9;
	width: 100vw;
`
